<div class="base-header">
  <h2>{{ 'RECIPES_EDIT.BASE.TITLE' | translate }}</h2>
</div>

<div class="bloc-base-preparation">
  <div class="background-base-preparation">
    <div class="headers">
      <div class="column-ingredient">{{ 'RECIPES_EDIT.BASE.DESCRIPTION' | translate }}</div>
      <div class="column-base">{{ 'RECIPES_EDIT.BASE.BASE_PREPARATION' | translate }}</div>
      <div class="column-actions">&nbsp;</div>
      <div class="column-space">&nbsp;</div>
    </div>

    <ng-container *ngFor="let formGroupIngredient of formGroups">
      <div class="column-type" *ngIf="formGroupIngredient.value.ingredientRecipe">
        <div class="base-line">
          <div class="column-ingredient">
            <mat-form-field appearance="fill" class="form-field-ingredient form-field-no-header">
              <input matInput type="text" [(ngModel)]="formGroupIngredient.value.applicationDescription" [disabled]="true" />
            </mat-form-field>
          </div>

          <div class="column-base">
            <app-form-field-select-autocomplete
              class="input-center form-field-no-header"
              [(model)]="formGroupIngredient.value.ingredientRecipe.title"
              [useModel]="true"
              [showBracket]="false"
              [completeList]="recipeTitles"
              (inputValueChanged)="search($event)"
              [minAutocompleteLength]="3"
              [singleValueMode]="true"
              (modelChange)="updateIngredientRecipe(formGroupIngredient)"
              appearance="fill"
            ></app-form-field-select-autocomplete>
          </div>

          <div class="column-actions">
            <button mat-button class="btn delete-button" (click)="delete(formGroupIngredient)">
              <i class="fas fa-trash space-v-s" aria-hidden="true"></i>
            </button>
          </div>
          <div class="column-space"></div>
        </div>
      </div>
    </ng-container>

    <div class="base-line" *ngIf="availableIngredients().length > 0">
      <div class="column-ingredient">
        <mat-form-field appearance="fill" class="field-unit form-field-no-header form-field-ingredient">
          <mat-select id="RecipesModifyIngredientBasicPrepBtn" (valueChange)="ingredientSelected($event)">
            <div id="RecipesModifyIngredientBasicPrepLst">
              <mat-option *ngFor="let ingredient of availableIngredients()" [value]="ingredient">
                {{ ingredient.value.applicationDescription }}
              </mat-option>
            </div>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
